'use strict';

/**
 * Default dashboard index view
 *
 * @category   View
 * @module     dashboard
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var BaseLayout = require('modules/collection/views/layout/base');
var ImportUnfinishedList = require('modules/collection/modules/import/views/partials/import-unfinished-list');
var ConversationsListView = require('modules/community/views/partials/conversations-list');
var ListViewFactory = require('modules/collection/views/partials/list-factory');
var SetsListView = require('modules/collection/modules/set/views/partials/sets-list');
var SetObjectSettingsListModel = require('modules/collection/modules/set/models/settings-object-list');
var StoragesListView = require('modules/collection/modules/location/views/partials/storages-list');

var template = require('modules/dashboard/templates/layout/index.hbs');

var IndexLayout = BaseLayout.extend({
    template: template,

    className: 'dashboard-container',

    regions: {
        importsRegion: '.dashboard-imports-region',
        conversationsRegion: '.dashboard-conversations-region',
        collectionRegion: '.dashboard-collection-region',
        setsRegion: '.dashboard-sets-region',
        storagesRegion: '.dashboard-storages-region',
    },

    ui: {
        container: '.dashboard-container',
        collectionContainer: '.container-collection',
    },

    /**
     * Collection for the unfinished items
     * @type {Colido.Collection}
     */
    collectionUnfinishedImports: null,

    initialize: function(options) {
        BaseLayout.prototype.initialize.apply(this, arguments);

        this.catalog = this.getOption('catalog');

        this.collectionUnfinishedImports = this.catalog.imports.unfinished();
        this.listenTo(this.collectionUnfinishedImports, 'add remove sync change', this.checkImportListRegions.bind(this));
    },

    onRender: function() {
        BaseLayout.prototype.onRender.apply(this, arguments);

        //IMPORTS
        this.importsRegion.show(new ImportUnfinishedList({
            collection: this.collectionUnfinishedImports,
        }));

        this.checkImportListRegions();

        //CONVERSATIONS
        if (App.CommunityModule) {
            var conversationsListView = new ConversationsListView({
                collection: App.CommunityModule.conversationsCollection,
                infiniteView: true,
            });
            this.conversationsRegion.show(conversationsListView);
        }

        //COLLECTION
        var listViewFactory = new ListViewFactory();
        var listView = listViewFactory.createListView('slider', {
            catalog: this.catalog,
            collection: this.catalog.objects,
            model: this.getOption('settingsModel'),
            sortDefault: 'modifiedTime.desc',
            itemLimit: 10,
        });

        this.collectionRegion.show(listView);

        //SETS
        var setsView = new SetsListView({
            catalog: this.catalog,
            collection: this.catalog.sets,
            model: new SetObjectSettingsListModel(),
            moduleParams: this.getOption('settingsModel'),//App.CollectionModule.controller.params,
            // prependEmpty: true,
            prependEmpty: false,
            infiniteView: true,
            // displayImage: false,
            context: 'dashboard',
            sortDefault: 'modifiedTime.desc',
        });
        this.setsRegion.show(setsView);

        //STORAGES
        var storagesView = new StoragesListView({
            catalog: this.catalog,
            collection: this.catalog.storages,
            infiniteView: true,
            sortDefault: 'modifiedTime.desc',
            filter: function(model) {
                return model.get('storType') === 'room';
            },
        });
        this.storagesRegion.show(storagesView);
    },

    viewData: {
        catalogBasePath: function() {
            return '/catalogs/' + this.catalog.id;
        },
    },

    /**
     * Checks, if the regions with the lists should be shown
     */
    checkImportListRegions: function() {
        this.ui.container.toggleClass('has-unfinished-imports', this.collectionUnfinishedImports.length > 0);
    },
});

module.exports = IndexLayout;